import { render } from "./StockAnalysisChartPage.vue?vue&type=template&id=3388c5ae&scoped=true"
import script from "./StockAnalysisChartPage.vue?vue&type=script&lang=js"
export * from "./StockAnalysisChartPage.vue?vue&type=script&lang=js"

import "./StockAnalysisChartPage.vue?vue&type=style&index=0&id=3388c5ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3388c5ae"]])

export default __exports__